import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";

const ServiceTypeList = (props: any) => {
  const { handleIsActive } = props;
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.SERVICE_TYPE}
      queryKey={"service-type"}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      tableName={"service-type"}
    />
  );
};

export default ServiceTypeList;
